require.register("modules/m04/m04-activity/page-4-me-ny/page-4-me-ny", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_4_me_ny = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_4_me_ny;

  
});

